import { hotTopics } from "@/mocks/gossipData";

export default function Topics() {
  return (
    <section id="topics" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div>
            <p className="text-accent-600 font-heading text-sm mb-1">TOP TOPICS</p>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">话题广场</h2>
            <p className="text-sm text-foreground-600">今天大家都在聊什么，进来插一嘴</p>
          </div>
          <a
            href="#faq"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            更多话题 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {hotTopics.map((topic, i) => (
            <a
              key={topic.id}
              href="#live"
              className="card-lift rounded-2xl p-4 md:p-5 flex items-center gap-4 hover:border-primary-200 transition-colors group"
            >
              <span className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-secondary-100 text-secondary-900 font-heading text-lg md:text-xl flex items-center justify-center shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="inline-flex items-center gap-1 text-xs text-accent-700 bg-accent-100 rounded-full px-2 py-0.5 whitespace-nowrap">
                    <i className="ri-fire-fill"></i>
                    {topic.tag}
                  </span>
                  <h3 className="text-sm md:text-base font-medium text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                    {topic.title}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 flex flex-wrap items-center gap-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-group-line"></i>
                    {topic.participants}
                  </span>
                  <span>{topic.heat}</span>
                </p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 group-hover:translate-x-1 transition-all"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}